import type { SVGProps } from "react";

interface BuildingIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

export function BuildingIcon({ size = 16, ...props }: BuildingIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 14V4L8 2L14 4V14H2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 6H5.01M8 6H8.01M11 6H11.01M5 9H5.01M8 9H8.01M11 9H11.01M5 12H11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
